// DS: C60
import React, { /* useCallback,  */ useContext } from 'react';
import { useTranslation } from 'react-i18next';
import readableFileSize from 'filesize';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { formatDollars } from '../../../../utils/formatting';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import noop from '../../../../utils/noop';
import Button from '../../../../Button';
import { getDeviationPremiumDownload } from '../permissions';
import PremiumAssetList from './PremiumAssetList';
import s from './PremiumPurchasePopover.scss';
var logger = ddt.createLogger('downloadbutton');
var PremiumPurchasePopover = function (_a) {
    // precondition: just for purchasing - purchased, subscribed, and owned
    // downloads will see a simpler download link
    var _b, _c;
    var deviation = _a.deviation, _d = _a.closeTooltip, closeTooltip = _d === void 0 ? noop : _d;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var download = getDeviationPremiumDownload(deviation, false).download;
    if (!download) {
        logger.log('PremiumPurchasePopover, no download');
        return null;
    }
    // premium pricing in title, filelist in subtitle
    var downloadPrice = download.downloadPrice, downloadDollarPrice = download.downloadDollarPrice, assets = download.assets, zipFilesize = download.zipFilesize;
    var showPriceInPoints = downloadPrice && downloadPrice < 80;
    var titleKey = showPriceInPoints
        ? 'actionbar.download.premium.pointPrice'
        : 'actionbar.download.premium.currencyPrice';
    var titleWithPrice = t(titleKey, {
        price: downloadPrice,
        dollars: formatDollars(downloadDollarPrice),
    });
    // list the files included in the subtitle
    var fileTypesIncluded = (assets || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    var checkoutUrl = ((_b = deviation.pcp) === null || _b === void 0 ? void 0 : _b.subproductId)
        ? Url.checkoutLink((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.subproductId)
        : undefined;
    logger.log('PremiumPurchasePopover', { checkoutUrl: checkoutUrl });
    var contents = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['popover-title'] }, t('actionbar.download.downloadDeviation')),
        React.createElement("div", { className: s['download-description'] },
            React.createElement("div", { className: s['download-price'] }, titleWithPrice),
            React.createElement("div", { className: s['download-contents'] }, t('actionbar.download.premium.size', {
                size: readableFileSize(zipFilesize || 0),
                types: fileTypesIncluded,
            }))),
        React.createElement(PremiumAssetList, { assets: download.assets }),
        React.createElement(Button, { className: s['purchase-button'], view: "b18", href: checkoutUrl, biData: PureBiData({
                evid: 351,
                deviationid: deviation.deviationId,
            }) }, t('actionbar.download.mustPurchase'))));
    return isMobile ? (React.createElement(DSModal, { isOpen: true, onRequestClose: closeTooltip, heading: t('actionbar.download.mobile.premiumDownload'), contentClassName: s['root'], showHeaderBorder: true }, contents)) : (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
        React.createElement("div", { className: s['root'] }, contents)));
};
PremiumPurchasePopover.displayName = 'PremiumPurchasePopover';
export default PremiumPurchasePopover;
//# sourceMappingURL=PremiumPurchasePopover.js.map